// ============================================
// CONTRACT ADDRESSES
// Xterra + XterraPools are separate contracts now.
// Pools is optional — set to zero address if not deployed yet.
// ============================================

import { ACTIVE_NETWORK } from './networks';

const ADDRESSES = {
  mainnet: {
    Xterra:      '0x2Fd23cdc8F95a7A75F2869e59BCFAA59fEbB0f73', // TODO: fill after deploy
    XterraPools: '0x477be15768a78da94264017ba513605da753b439', // TODO: fill after deploy
    USDT:        '0x55d398326f99059fF775485246999027B3197955',
    XT:          '0x4cD5139fAc3E967A29122092D9E3734554e537d0', // TODO: fill after deploy
  },
  testnet: {
    Xterra:      '0xad2d8B51Ed1BAb4FAF15140E9845e9477a86e769', // deployed
    XterraPools: '0x0c17b57e40a1e66504c5f67dc0ce351915d331be', // TODO: deploy Pools then fill
    USDT:        '0x2620D043772DdE2a4B5cfBB807Aa3ebd678DD1DC',
    XT:          '0xcD15c352b2C427e0E9c1141acEb94B46A3eE51fB',
  },
};

const active = ADDRESSES[ACTIVE_NETWORK];

// Backward-compat aliases (old components read these keys)
export const CONTRACTS = {
  ...active,
  XterraLogic:   active.Xterra,
  XterraStorage: active.Xterra,
};
